(function userQueryModuleDefinition() {

    'use strict';

    angular.module('UserQuery', [ 'Config', 'Entities', 'ClickOnce'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function userQueryConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('user-query-find', {
                    url: "/UserQuery/List",
                    templateUrl: config.resourceUrl('/views/user-query/list.html'),
                    controller: 'UserQueryFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('USER QUERIES')
                });

            }
        ]);
})();